import styled from 'styled-components/native';

export const ActionButtonContainer = styled.View`
  align-items: center;
`;
